<template>
    <div class="container-fluid page-content"></div>
</template>

<script>
import { mapState } from 'vuex';
import navItems from '@/nav';
import _ from 'lodash';
import CONSTANTS from '../constants';
export default {
    data() {
        return {
            navItems
        };
    },
    mounted: function () {
        this.$nextTick(async function () {
            this.onRouteChange();
        });
    },
    computed: {
        ...mapState({
            currentUserFunctions: state =>
                _.cloneDeep(_.get(state.auth, 'currentUser.userDetail.functions')),
            currentUser: state => state.auth.currentUser
        })
    },
    watch: {
        $route(val) {
            this.onRouteChange();
        }
    },
    methods: {
        getRouteList() {
            if (!this.currentUserFunctions) return CONSTANTS.COMMON_NAV;
            const selectingView = this.$route.query.view || this.currentUser.selectedView;
            const listNavItems = [];
            if (selectingView) {
                listNavItems.push(...this.navItems[selectingView].children);
            } else {
                Object.values(this.navItems).forEach(navItem => {
                    listNavItems.push(...navItem.children);
                });
            }
            return listNavItems;
        },
        getDefaultRoute() {
            const listNavItems = this.getRouteList();
            const result = _.find(listNavItems, ['isDefault', true]);
            return result;
        },
        getFirstValidUserFunction() {
            const listNavItems = this.getRouteList();
            if (_.isEqual(listNavItems, CONSTANTS.COMMON_NAV)) return null;
            let userFunctionList = [];
            listNavItems.forEach(navItem => {
                userFunctionList.push(...navItem.permissions);
            });
            userFunctionList = _.uniq(userFunctionList);

            let firstValidUserFunction = null;
            (this.currentUserFunctions || []).forEach(userFunc => {
                if (userFunctionList.indexOf(userFunc) > -1) {
                    firstValidUserFunction = userFunc;
                    return;
                }
            });
            return firstValidUserFunction;
        },
        onRouteChange() {
            const defaultRoute = this.getDefaultRoute();
            let hasPermissionForDefaltRoute = false;
            if (defaultRoute && defaultRoute.permissions && defaultRoute.permissions.length > 0) {
                defaultRoute.permissions.forEach(el => {
                    if (
                        this.currentUserFunctions &&
                        this.currentUserFunctions.indexOf(defaultRoute > -1)
                    ) {
                        hasPermissionForDefaltRoute = true;
                    }
                });
            }
            if (defaultRoute && hasPermissionForDefaltRoute) {
                this.$router.push(defaultRoute.url);
            } else {
                const func = this.getFirstValidUserFunction();
                if (!func) this.$router.push('/dashboard');
                switch (func) {
                    case 'user':
                        this.$router.push('/user');
                        break;
                    case 'system':
                        this.$router.push('/system');
                        break;
                    case 'database':
                        this.$router.push('/database');
                        break;
                    case 'news':
                        this.$router.push('/news/news');
                        break;
                }
            }
        }
    }
};
</script>
